import { typeCreatorV2 } from '../../../redux/utils/common';

export const GET_CLIENT_CLIENT_REQUEST: string = typeCreatorV2(
  'ClientRequestReducer',
  'GetClientRequest'
);

// export const CREATE_NOTE: string = typeCreatorV2(
//   'ClientSavedSearchReducer',
//   'CreateNote'
// );

export const DELETE_CLIENT_REQUEST: string = typeCreatorV2(
  'ClientSavedSearchReducer',
  'DeleteSavedSearch'
);

export const UPDATE_CLIENT_REQUEST: string = typeCreatorV2(
  'ClientSavedSearchReducer',
  'UpdateSavedSearch'
);
